import type { CollisionShape, Point, Polygon, Rect } from '../geometry';
import type { RegionZone, RegionZoneKind } from '../region-definition';

export interface SerializedMapData {
  blockers: Array<
    | { kind: 'rect'; id: string; x: number; y: number; w: number; h: number }
    | { kind: 'polygon'; id: string; points: Point[] }
  >;
}

export interface SerializedZoneData {
  zones: Array<{ id: string; kind: string; area: Rect | Polygon }>;
}

function translateArea(area: Rect | Polygon, offsetX: number, offsetY: number, scale: number): Rect | Polygon {
  if ('kind' in area) {
    return {
      ...area,
      points: area.points.map((point) => ({ x: point.x * scale + offsetX, y: point.y * scale + offsetY })),
    };
  }
  return { ...area, x: area.x * scale + offsetX, y: area.y * scale + offsetY, w: area.w * scale, h: area.h * scale };
}

export function translatedRegionData(
  collision: SerializedMapData,
  zones: SerializedZoneData,
  offsetX: number,
  offsetY: number,
  scale = 1,
): { collision: readonly CollisionShape[]; zones: readonly RegionZone[] } {
  return {
    collision: collision.blockers.map((blocker) =>
      blocker.kind === 'rect'
        ? { ...blocker, x: blocker.x * scale + offsetX, y: blocker.y * scale + offsetY, w: blocker.w * scale, h: blocker.h * scale }
        : {
            ...blocker,
            points: blocker.points.map((point) => ({
              x: point.x * scale + offsetX,
              y: point.y * scale + offsetY,
            })),
          },
    ),
    zones: zones.zones.map((zone) => ({
      id: zone.id,
      kind: zone.kind as RegionZoneKind,
      area: translateArea(zone.area, offsetX, offsetY, scale),
    })),
  };
}
